<template>
  <div class="public-print-list" v-if="parameter.visable">
    <el-dialog class="public-print-list-dialog" :visible.sync="parameter.visable" :title="parameter.name" width="670px" height="378px" center :close-on-click-modal="false">
      <div class="dialog-content">
        <el-button type="primary" class="add-button" @click="addTemplate">新建</el-button>
        <div class="table">
          <el-table v-if="tableData.length" :data="tableData" v-loading="loading" height="240px" header-row-class-name="header-class">
            <el-table-column prop="model_name"
                             label="名称"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="createdTime"
                             label="创建时间"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
             <el-table-column
                             prop="lastModifiedTime"
                             label="修改时间"
                             align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="editPrint(scope.row)">设计模板</el-button>
              <el-button class="del-row" type="text" @click="delPrint(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          </el-table>
          <div v-else class="no-list">
            <img src="@/globalComponent/calculation/assets/nothing.png" alt="无内容">
            <p>点击右上角新建按钮，创建模版</p>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="parameter.visable = false">{{tableData.length?'关闭':'取消'}}</el-button>
      </span>
       <el-dialog
       class="create-template-dialog"
        width="370px"
        :visible.sync="createTemplate.visible"
        append-to-body
        center>
        <div class="modal-body">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item label="模板名称" class="print-name">
                <el-input ref="createTemplate" v-model="createTemplate.name" @keyup.enter.native="saveName" maxlength="50" placeholder="未命名模板"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer" >
            <el-button type="primary" @click="saveName">创建</el-button>
            <el-button @click="createTemplate.visible=false">取 消</el-button>
          </div>
    </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'public-print-list',
  props: ['parameter'],
  data () {
    return {
      tableData: [],
      loading: true,
      firstDataId: '',
      createTemplate: {
        visible: false,
        name: ''
      }
    }
  },
  methods: {
    addTemplate () {
      this.createTemplate.visible = true
      this.createTemplate.name = ''
      this.$nextTick(() => {
        this.$refs.createTemplate.focus()
      })
    },
    saveName () {
      if (!this.createTemplate.name) {
        this.$message.info('请输入模板名称')
        return false
      }
      this.createTemplate.visible = false
      this.$axios.post(`/shared-api/print/saveName/${this.parameter.id}/${this.createTemplate.name}`).then(res => {
        this.createTemplate.name = ''
        this.loadList()
      })
    },
    editPrint (row) {
      this.createTemplate.visible = false
      this.parameter.visable = false
      let href = this.$router.resolve({name: 'CustomPrint', query: { id: row.id, definitionId: this.parameter.id, type: this.parameter.type, token: this.$route.query.token }}).href
      window.open(href, '_blank')
    },
    delPrint (row) {
      let id = row.id
      this.$confirm('', '您确定要删除当前模版么？', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        customClass: 'publishMessageBoxtwo',
        center: true
      })
        .then(() => this.$axios.delete('/shared-api/print/' + id))
        .then(res => {
          this.loadList()
        })
    },
    loadList () {
      let url = `/shared-api/print/findAllByDefinitionId`
      this.$axios.get(`${url}`, {params: {definitionId: this.parameter.id}}).then(res => {
        this.tableData = res.data || []
      })
    }
  },
  watch: {
    'parameter.visable' (val) {
      if (val) {
        try {
          this.loadList()
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .public-print-list-dialog {
    .el-dialog.el-dialog--center{
      margin-top: 14% !important;
        .el-dialog__header {
          padding: 5px 20px;
        }
        .el-dialog__body {
          padding: 20px 20px 0 20px;
          height: 300px;
        }

        .dialog-content {
          .add-button {
            width: 58px;
            height: 24px;
            line-height: 24px;
            padding: 0;
            float:right;
            margin-bottom: 10px;
          }
          & > .table {
            .no-list {
              margin: 0 auto 0;
              text-align: center;
              color: #999999;
              font-size: 12px;
              height: 200px;
              padding-top: 70px;
            }
            .del-row {
              color: #A5A5A5;

              &:hover {
                color: #F64D5E;
              }

              &:active {
                color: #FB9391;
              }
            }

            .el-table__header {
              border-bottom: 1px solid #EBEBEB;
            }

            .header-class {
              th {
                background-color: #fff;
              }
            }
          }

        }

        .el-dialog__footer {
          padding: 31px 0 21px 0;

          .el-button {
            width:84px;
            height:26px;
            border-radius:4px;
            padding: 0;
          }
        }
    }
  }
  .create-template-dialog {
    >.el-dialog.el-dialog--center {
      margin-top: 22% !important;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 48px 36px 28px;
        .el-input {
          width: 220px;
        }
      }
      .el-dialog__footer {
        padding-top: 0;
        .dialog-footer {
          .el-button {
            padding: 5px 26px;
            &:nth-child(2){
              margin-left: 42px;
            }
          }

        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/shared/public-print-list.vue